export default __webpack_public_path__ + "static/media/logo.bafa49fa.png";